import React from 'react';
import { Row, Col } from 'antd';

export const List = ({ parkings }) => (
  <Row>
    <Col>
      <ul>
        {parkings.map(({ properties: { id, NAME: name, LV_CPY: capacity } }) => (
          <li
            key={id}
          >
            {name}
            {capacity && ` (${capacity} pl.)`}
          </li>
        ))}
      </ul>
    </Col>
  </Row>
);

export default List;



// WEBPACK FOOTER //
// ./src/components/Summary/ParkingsList/List.js